var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayMediumCustomGender = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "display-icon/small/budget copy 18") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Checklist/Video",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_wc_48px-copy",
    transform: "translate(5.4, 3)",
    fill: "#1E2969",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.728,23.04 L1.728,14.4 L0,14.4 L0,8.064 C0,6.7968 1.0368,5.76 2.304,5.76 L5.76,5.76 C7.0272,5.76 8.064,6.7968 8.064,8.064 L8.064,14.4 L6.336,14.4 L6.336,23.04 L1.728,23.04 Z M16.128,23.04 L16.128,16.128 L19.584,16.128 L16.65216,7.33824 C16.34112,6.3936 15.45984,5.76 14.46912,5.76 L14.33664,5.76 C13.34592,5.76 12.46464,6.3936 12.1536,7.33824 L9.216,16.128 L12.672,16.128 L12.672,23.04 L16.128,23.04 Z M4.032,4.608 C5.30496,4.608 6.336,3.57696 6.336,2.304 C6.336,1.03104 5.30496,0 4.032,0 C2.75904,0 1.728,1.03104 1.728,2.304 C1.728,3.57696 2.75904,4.608 4.032,4.608 Z M14.4,4.608 C15.67296,4.608 16.704,3.57696 16.704,2.304 C16.704,1.03104 15.67296,0 14.4,0 C13.12704,0 12.096,1.03104 12.096,2.304 C12.096,3.57696 13.12704,4.608 14.4,4.608 Z",
    id: "Shape"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayMediumCustomGender);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-medium-custom-gender.d61d7708b0f94da1ba66d899609d0402.svg";